import React from 'react';
import { toast } from 'react-toastify';
import { parseErrors } from 'src/utils/api/error';
import ErrorMessage from './ErrorMessage';
import ErrorMessageWithButton from './ErrorMessageWithButton';

let lastError = null;

const error = (message, ...rest) => {
  if (
    lastError &&
    lastError.message === message &&
    toast.isActive(lastError.toastId)
  ) {
    return null;
  }

  const prepared = message instanceof Error ? parseErrors(message) : message;
  const text = Array.isArray(prepared) ? prepared.join(', ') : prepared;
  const toastId = toast.error(text, ...rest);

  lastError = {
    message,
    toastId,
  };

  return toastId;
};

const onQueryFailed = (query, message, refetch) => {
  return error(<ErrorMessage query={query} message={message} refetch={refetch} />, {
    autoClose: !refetch,
  });
};

const onButtonClick = () => {
  toast.dismiss('errorWithOk');
}

const onErrorWithOK = (message, okLabel, autoClose = true) => {
  return error(<ErrorMessageWithButton toastId={'errorWithOk'} message={message} buttonlabel={okLabel} onButtonClick={onButtonClick} />, {
    autoClose,
  });
};

const dismiss = (toastId) => toast.dismiss(toastId);

const notification = { ...toast, error, onQueryFailed, dismiss, onErrorWithOK };

// eslint-disable-next-line import/prefer-default-export
export { notification };
